"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MhCascader = void 0;

var _vuePropertyDecorator = require("vue-property-decorator");

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function list2Tree(l) {
  var list = JSON.parse(JSON.stringify(l));
  list.forEach(function (item) {
    if (item.parentId) {
      list.every(function (item2) {
        if (item2.value === item.parentId) {
          if (!item2.children) {
            item2.children = [];
          }

          item2.children.push(item);
          item.parent = item2;
        }

        return true;
      });
    }
  });
  return list.filter(function (item) {
    return !item.parent;
  });
}

function findValueByList(value, list) {
  var obj = list.find(function (item) {
    return item.value === value[0];
  });

  if (obj && obj.parentId) {
    var parent = list.find(function (item) {
      return item.value === obj.parentId;
    });

    if (parent) {
      return findValueByList([obj.parentId].concat(_toConsumableArray(value)), list);
    }
  }

  return value;
}

function getAllChildrenByValueList(value, options) {
  var result = [];

  if (value.length) {
    var obj = options.find(function (opt) {
      return opt.value === value[0];
    });

    if (value.length === 1) {
      result.push(value[0]);
    }

    if (obj && obj.children) {
      result.push.apply(result, _toConsumableArray(getAllChildrenByValueList(value.slice(1), obj.children)));
    }
  } else {
    options.forEach(function (opt) {
      result.push(opt.value);

      if (opt.children) {
        result.push.apply(result, _toConsumableArray(getAllChildrenByValueList([], opt.children)));
      }
    });
  }

  return result;
}

var MhCascader = (_dec = (0, _vuePropertyDecorator.Model)('change'), _dec2 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), _dec3 = (0, _vuePropertyDecorator.Prop)({
  default: 'label'
}), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: 'value'
}), _dec5 = (0, _vuePropertyDecorator.Prop)({
  default: 'parentId'
}), _dec6 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return 'default';
  }
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  _inherits(MhCascader, _Vue);

  var _super = _createSuper(MhCascader);

  function MhCascader() {
    var _this;

    _classCallCheck(this, MhCascader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_this, "value", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "options", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "optionLabel", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "optionValue", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "parentKey", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "type", _descriptor6, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(MhCascader, [{
    key: "onChange",
    value: function onChange(value) {
      if (this.type === 'selectAllChildren') {
        this.$emit('change', value && value[0] && getAllChildrenByValueList(value, this.factOptions));
      } else {
        this.$emit('change', value && value[value.length - 1]);
      }
    }
  }, {
    key: "render",
    value: function render(h) {
      var factOptions = this.factOptions,
          factValue = this.factValue,
          onChange = this.onChange;
      return h('a-cascader', {
        props: _objectSpread(_objectSpread({}, this.$attrs), {}, {
          options: factOptions,
          value: factValue
        }),
        on: {
          change: onChange
        }
      });
    }
  }, {
    key: "labelValueOptions",
    get: function get() {
      var options = this.options,
          optionLabel = this.optionLabel,
          optionValue = this.optionValue,
          parentKey = this.parentKey;
      return options.map(function (opt) {
        return _objectSpread(_objectSpread({}, opt), {}, {
          label: opt[optionLabel],
          value: opt[optionValue],
          parentId: opt[parentKey]
        });
      });
    }
  }, {
    key: "factOptions",
    get: function get() {
      return list2Tree(this.labelValueOptions);
    }
  }, {
    key: "factValue",
    get: function get() {
      if (!this.value) {
        return [];
      }

      if (this.type === 'selectAllChildren') {
        return findValueByList([this.value[0]], this.labelValueOptions);
      }

      return findValueByList([this.value], this.labelValueOptions);
    }
  }], [{
    key: "install",
    value: function install(vue) {
      vue.component('mh-cascader', this);
    }
  }]);

  return MhCascader;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "options", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "optionLabel", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "optionValue", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "parentKey", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.MhCascader = MhCascader;